// Formats ISO date string to {MONTH DD}
export function isoToMonthDate(isoString) {
    return new Date(isoString).toLocaleDateString([], { month: "long", day: "numeric" });
}

// Formats ISO date string to {MONTH DD, YYYY}
export function isoToMonthDateYear(isoString) {
    return new Date(isoString).toLocaleDateString([], { month: "long", year: "numeric", day: "numeric" });
}

// Formats GMT ISO date string to {MONTH DD, YYYY HH:MM AM/PM} in user's local timezone
export function isoToMonthDateYearTime(isoString) {
    // Assuming you have a date string in GMT format
    var gmtDateString = isoString;

    var gmtDate = new Date(gmtDateString);
    var localTimeZoneOffset = new Date().getTimezoneOffset();

    // Adjusting for local timezone (this part is fine if you want to keep it)
    gmtDate.setMinutes(gmtDate.getMinutes() - localTimeZoneOffset);

    // Specify options to format the date without seconds
    var options = {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true // For AM/PM format
    };

    // Display the adjusted date in the specified format
    var localDateString = gmtDate.toLocaleString('en-US', options);

    return localDateString;
}

// Formats ISO date string to human readable time elapsed since arg 
export function isoToTimestamp(isoString) {
    let dateFormatObj = new Date(isoString)

    let difference = Date.now() - (dateFormatObj.getTime() - 25200000);

    function msToTime(ms, date) {

        // let seconds = (ms / 1000).toFixed(1);
        let minutes = Math.floor(ms / (1000 * 60));
        let hours = Math.floor(ms / (1000 * 60 * 60));
        let days = Math.floor(ms / (1000 * 60 * 60 * 24));
        let weeks = Math.floor(ms / (1000 * 60 * 60 * 24 * 7));
        let months = Math.floor(ms / (1000 * 60 * 60 * 24 * 7 * 4));

        if (minutes < 60) return minutes + " min"
        else if (hours < 24) return hours + " hr"

        else if (days < 2) return days + " day"
        else if (days < 7) return days + " days"

        else if (weeks < 2) return weeks + " week"
        else if (weeks < 4) return weeks + " weeks"

        else if (months < 2) return months + " month"
        else if (months < 12) return months + " months"

        else return (isoToMonthDateYear(date))
    }

    return (msToTime(difference, dateFormatObj))
}
// Function to format the date in the specified style
export const formatDate = (dateString) => {
    if (!dateString) return ""; // Handle null or undefined input

    const date = new Date(dateString);

    if (isNaN(date)) {
        console.error(`Invalid date: ${dateString}`);
        return "Invalid Date"; // Return a fallback message for invalid dates
    }

    const options = {
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric', 
        hour: 'numeric', 
        minute: '2-digit', 
        hour12: true
    };

    return date.toLocaleString(undefined, options); // Use locale-aware formatting
};

